



































import {Component, Prop, Vue} from 'vue-property-decorator';

export interface ColumnDefinition {
  name: string;
  title: string;
  width: string;
}

export interface ColumnClassDefinition {
  name: string;
  class: string;
}

@Component({})
export default class DataTable extends Vue {
  @Prop() public idColumnName!: string;
  @Prop() public columns!: ColumnDefinition[];
  @Prop() public columnClasses!: ColumnClassDefinition[];
  @Prop() public rowsCount!: number;
  @Prop() public translate!: {};
  @Prop() public enableScroll!: boolean;

  get columnClassObjects() {
    const objects: any = {};
    if (this.columns.length) {
      this.columns.forEach((c: any) => objects[c.name] = {});
    }
    if (this.columnClasses && this.columnClasses.length) {
      this.columnClasses.forEach((cc: any) => objects[cc.name] = {[cc.class]: true});
    }
    return objects;
  }
}
